import { Outlet } from 'react-router';

import { Flex } from '@valwin/facto/components';
import {
  AppGrid,
  MobileHeader,
  PageProvider,
  SidebarProvider,
  TopBar,
  usePageTitle,
  useSidebar,
} from '@valwin/facto/widgets';

import { LanguageSelector } from '~features/language-selector';
import { LogoHorizontal, LogoSmall } from '~shared/ui';
import { Profile } from '~widgets/profile';
import { SidebarNavDesktop, SidebarNavMobile } from '~widgets/sidebar';

const SIDEBAR_OPEN_KEY = 'vw-pharma-sidebar-open';

function Actions() {
  return (
    <>
      <Profile />
      <LanguageSelector />
    </>
  );
}

function Layout() {
  const { title } = usePageTitle();
  const { isOpen } = useSidebar();

  return (
    <AppGrid
      isOpen={isOpen}
      logo={
        <Flex
          background="white"
          borderRadius="xl"
          alignItems="center"
          justifyContent="center"
          width="full"
          height="full"
          padding="2"
        >
          {isOpen ? <LogoHorizontal /> : <LogoSmall />}
        </Flex>
      }
      nav={<SidebarNavDesktop />}
      topbar={<TopBar title={title} actions={<Actions />} />}
      mobileHeader={
        <MobileHeader
          logo={<LogoSmall />}
          nav={<SidebarNavMobile />}
          title={title}
          actions={<Actions />}
        />
      }
    >
      <Outlet />
    </AppGrid>
  );
}

export function AuthenticatedLayout() {
  return (
    <PageProvider>
      <SidebarProvider openKey={SIDEBAR_OPEN_KEY} defaultOpen>
        <Layout />
      </SidebarProvider>
    </PageProvider>
  );
}
